import { css } from '@emotion/react';
import { RoomType } from '$/GraphQL/schema/schema';
import React from 'react';
import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { PlayerMode } from '$/components/WebinarPlayer/types';
import isMobile from '$/utils/isMobile';
import Button from '../../ui/Button/Button';
import DropdownComponent from '../../ui/Input/Basics/DropdownComponent';

type SpeedValue = 0.5 | 0.75 | 1 | 1.25 | 1.5 | 1.75 | 2;

const speedOptions: {
  label: string;
  value: SpeedValue;
}[] = [
  { label: '2x', value: 2 },
  { label: '1.75x', value: 1.75 },
  { label: '1.5x', value: 1.5 },
  { label: '1.25x', value: 1.25 },
  { label: 'Normal', value: 1 },
  { label: '0.75', value: 0.75 },
  // { label: '0.5x', value: 0.5 },
];

export const SpeedControlButton: React.FC<{
  className?: string;
}> = withWebinarPlayerContext(
  ['playbackSpeed', 'setPlaybackSpeed', 'loaded', 'currentRoom', 'mode', 'ewebinar'],
  'SpeedControlButton'
)(({ className, context }) => {
  const { playbackSpeed, setPlaybackSpeed, currentRoom, mode, ewebinar } = context;

  const speedText = `${playbackSpeed}x`;
  const isShown =
    currentRoom.type === RoomType.Presentation &&
    (mode !== PlayerMode.live || Boolean(ewebinar.viewerRoomSettings?.enableVideoPlaybackSpeed));
  return (
    <DropdownComponent
      className={`control ${isShown ? '' : 'hidden'}`}
      css={css`
        -webkit-tap-highlight-color: transparent;
        .dropdown-content {
          background: rgba(0, 0, 0, 0.8) !important;
          color: #fff !important;
          border: none !important;
          justify-items: center !important;
        }
      `}
    >
      <DropdownComponent.Reference>
        <Button
          className={`${className} control appearance-none  z-60 outline-none ${
            isMobile ? 'text-base' : 'text-xl'
          }`}
          small
        >
          {speedText}
        </Button>
      </DropdownComponent.Reference>
      <DropdownComponent.Options
        placement='top'
        className={`bg-transparent shadow dropdown-content ${isMobile ? 'left-auto' : ''}`}
        modifiers={[{ name: 'flip', enabled: false }]}
      >
        {speedOptions.map(({ label, value }) => (
          <DropdownComponent.Options.Item
            className={`
                ${isMobile ? 'px-1 text-base max-h-2e' : 'text-xl h-2_5e'}
                ${
                  value === playbackSpeed ? 'font-bold justify-center' : 'opacity-70 justify-center'
                }
              `}
            key={value}
            onClick={(): void => setPlaybackSpeed(value)}
          >
            {label}
          </DropdownComponent.Options.Item>
        ))}
      </DropdownComponent.Options>
    </DropdownComponent>
  );
});
